import React, { Component } from "react";
import Header from "./Header";
import history from "../Utils/History";
import { connect } from "react-redux";
import { INITIAL_STATE } from "./initialState";
import {
  yearSelection,
  removeplan,
  agentCategoryDashboard,
  setStateParams,
  setLoginStateParams,
  getPlansEmail,
  guestLogin,
  setTokenTORedux,
  setDeepLink,
  getZipCodes,
  getPlans,
  setPageName,
  setLoginStateValues,
  getAgencyId,
} from "../Redux/Actions/webAppActions";
import { getKeyCloakToken } from "../Redux/Actions/keyCloakAction";
import Sidebar from "./Sidebar";
import PlansList from "./PlansList";
class SelectPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarExpanded: true,
      compareList: this.props.selectedPlansForCompare,
      planTypeFilter: this.props.planType ?? "",
      premiumFilter: "",
      productFilter: this.props.selectedProduct,
      clicked: false,
    };
  }

  async componentWillMount() {
    let queryString = window.location.search;
    let customerId = "";
    let zipCd = "";
    let countyCd = "";
    let stateCd = "";
    let countyName = "";
    let productID = "";
    let username = "";
    let year = "";
    let userRole = "";
    let token = "";

    if (queryString.includes("deepLink=true")) {
      let queryStringArray = queryString.split("&");
      queryStringArray.forEach((element) => {
        if (element.includes("customerId")) {
          customerId = window.atob(element.split("=")[1]);
        } else if (element.includes("zipCd")) {
          zipCd = window.atob(element.split("=")[1]);
        } else if (element.includes("countyCd")) {
          countyCd = window.atob(element.split("=")[1]);
        } else if (element.includes("stateCd")) {
          stateCd = window.atob(element.split("=")[1]);
        } else if (element.includes("countyName")) {
          countyName = window.atob(element.split("=")[1]);
        } else if (element.includes("productId")) {
          productID = window.atob(element.split("=")[1]);
        } else if (element.includes("email")) {
          username = window.atob(element.split("=")[1]);
        } else if (element.includes("planYear")) {
          year = window.atob(element.split("=")[1]);
        } else if (element.includes("userRole")) {
          userRole = window.atob(element.split("=")[1]);
        } else if (element.includes("token")) {
          token = element.split("=")[1];
        }
      });

      this.props.yearSelection(year);
      await this.props.setDeepLink({
        deeplink: true,
        countyName: countyName,
        zipcode: zipCd,
        productId: productID,
        stateCd: stateCd,
        email: username,
      });
      this.props.setStateParams("county", countyName);
      this.props.setStateParams("zip", zipCd);
      this.props.setLoginStateParams("deeplinkflag", true);
      await this.props.setStateParams("zip", zipCd);
      if (
        (userRole === "beneficiary" || userRole === "agent") &&
        !window.sessionStorage.getItem("isDeeplink")
      ) {
        window.sessionStorage.setItem("isDeeplink", window.location.href);
        window.sessionStorage.setItem("isDeepEmail", username);
        history.push("/e-Enroll/UserLogin");
        return;
      } else if (userRole === "guest") {
        let guestpayload = {
          customerId: customerId,
          username: this.props.dpemail,
        };
        const guestLoginDetails = await this.props.guestLogin(guestpayload);
        await this.props.setTokenTORedux(guestLoginDetails.data.token);
        await this.props.getZipCodes(zipCd);
        await this.props.getPlansEmail(
          zipCd,
          countyCd,
          customerId,
          stateCd,
          year,
          "Bearer " + guestLoginDetails.data.token
        );
      } else if (userRole === "beneficiary") {
        if (!window.sessionStorage.getItem("token")) {
          window.sessionStorage.setItem("isDeeplink", window.location.href);
          window.sessionStorage.setItem("isDeepEmail", username);
          history.push("/e-Enroll/UserLogin");
          return;
        }
        this.props.setLoginStateParams("beneficiaryLogin", true);
        await this.props.setTokenTORedux(
          window.sessionStorage.getItem("token")
        );
        await this.props.getZipCodes(zipCd);
        await this.props.getPlansEmail(
          zipCd,
          countyCd,
          customerId,
          stateCd,
          year,
          "Bearer " + window.sessionStorage.getItem("token")
        );
        window.sessionStorage.removeItem("isDeeplink");
        window.sessionStorage.removeItem("isDeepEmail");
      } else if (userRole === "agent") {
        if (token === "") {
          window.sessionStorage.setItem("isDeeplink", window.location.href);
          window.sessionStorage.setItem("isDeepEmail", username);
          history.push("/e-Enroll/UserLogin");
          return;
        }
        this.props.setLoginStateParams("agentLoggedIn", true);
        window.sessionStorage.setItem("token", token);
        window.sessionStorage.setItem("agentLoggedIn", true);
        this.props.setLoginStateParams("temporaryKeyCloaktoken", token);
        window.sessionStorage.removeItem("isDeeplink");
        window.sessionStorage.removeItem("isDeepEmail");
        const response = await this.props.getKeyCloakToken();
        window.sessionStorage.setItem(
          "keyCloakData",
          JSON.stringify(response.data)
        );
        await this.props.setStateParams("roles", response.data.roles);
        window.sessionStorage.setItem("token", response.data.token);
        this.props.setTokenTORedux(response.data.token);
        await this.props.setLoginStateParams(
          "agentEmailId",
          response.data.agentDetails?.agentEmail
        );
        await this.props.getAgencyId(
          response?.data?.agentId,
          window.sessionStorage.getItem("customerId")
        );
        await this.props.getZipCodes(zipCd);
        await this.props.getPlansEmail(
          zipCd,
          countyCd,
          customerId,
          stateCd,
          year,
          "Bearer " + response.data.token
        );
        let isAgentRole = false;
        let isSuperUser = false;
        let isAgencyAdmin = false;
        for (let i = 0; i < response.data.roles?.length; i++) {
          if (response.data.roles[i] === "AGENT") {
            isAgentRole = true;
          }
          if (
            response.data.roles[i] === "SUPER_USER" ||
            response.data.roles[i] === "AGENCY_ADMIN"
          ) {
            isSuperUser = true;
          }
          if (response.data.roles[i] === "AGENCY_ADMIN") {
            isAgencyAdmin = true;
          }
        }
        window.sessionStorage.setItem(
          "agencyIDSelected",
          this.props.agencyID[0].value?.trim()
        );
        await this.props.setLoginStateParams(
          "agencyIDSelected",
          this.props.agencyID[0].value?.trim()
        );
        await this.props.setStateParams("isAgentRole", isAgentRole);
        await this.props.setStateParams("isSuperUser", isSuperUser);
        await this.props.setLoginStateParams("isAgencyAdmin", isAgencyAdmin);
        window.sessionStorage.setItem("isSuperUser", isSuperUser);
        window.sessionStorage.setItem("isAgentRole", isAgentRole);
        window.sessionStorage.setItem("isAgencyAdmin", isAgencyAdmin);
      }
      history.push("/e-Enroll/select-plan");
    }
    if (this.props.zipCode === "" || this.props.zipCode === undefined) {
      let zipcd = window.sessionStorage.getItem("zipcode");
      if (zipcd) {
        await this.props.setStateParams("zip", zipcd);
        if (
          this.props.emailAddress === "" ||
          this.props.firstName === "" ||
          this.props.email === "" ||
          this.props.agentEmailId === undefined
        ) {
          if (window.sessionStorage.getItem("agentLogin") === "true") {
            this.props.setLoginStateParams(
              "agentEmailId",
              window.sessionStorage.getItem("email")
            );
            this.props.setLoginStateParams(
              "firstName",
              window.sessionStorage.getItem("firstName")
            );
            await this.props.setLoginStateParams(
              "agentFullName",
              window.sessionStorage.getItem("agentFullName")
            );
            this.props.setLoginStateParams("agentLoggedIn", true);
            this.props.setLoginStateParams(
              "agentId",
              window.sessionStorage.getItem("agentId")
            );
            this.props.setLoginStateParams(
              "agencyIDSelected",
              window.sessionStorage.getItem("agencyId")
            );
            this.props.setStateParams("guestLoggedIn", false);
            this.props.setLoginStateParams("guestLogin", false);
            this.props.setStateParams(
              "isAgentRole",
              window.sessionStorage.getItem("isAgentRole") === "true"
                ? true
                : false
            );
            this.props.setStateParams(
              "isSuperUser",
              window.sessionStorage.getItem("isSuperUser") === "true"
                ? true
                : false
            );
          }
          if (
            window.sessionStorage.getItem("guestLogin") === "false" &&
            window.sessionStorage.getItem("agentLogin") === "false"
          ) {
            this.props.setLoginStateParams(
              "emailAddress",
              window.sessionStorage.getItem("email")
            );
            this.props.setLoginStateParams(
              "firstName",
              window.sessionStorage.getItem("firstName")
            );
            this.props.setStateParams("guestLoggedIn", false);
            this.props.setLoginStateParams("guestLogin", false);
            this.props.setLoginStateParams(
              "authenticatedData",
              JSON.parse(window.sessionStorage.getItem("authenticatedData"))
            );
          }

          this.props.setLoginStateParams(
            "userId",
            window.sessionStorage.getItem("userId") ?? ""
          );
        }

        this.props.setLoginStateParams(
          "guestLogin",
          window.sessionStorage.getItem("guestLogin") == "true" ? true : false
        );
        this.props.setLoginStateParams(
          "agentLoggedIn",
          window.sessionStorage.getItem("agentLoggedIn") == "true"
            ? true
            : false
        );
        this.props.setLoginStateParams(
          "beneficiaryLogin",
          window.sessionStorage.getItem("beneficiaryLogin") == "true"
            ? true
            : false
        );

        if (this.props.token === "" || this.props.token === undefined) {
          await this.props.setTokenTORedux(
            window.sessionStorage.getItem("token")
          );
        }
        await this.props.getZipCodes(zipcd);

        if (zipcd.length === 5) {
          let call = true;

          if (this.props.ZipCodes && this.props.ZipCodes.length === 1) {
            await this.props.setStateParams(
              "county",
              this.props.ZipCodes[0].countyName
            );
          } else if (this.props.ZipCodes && this.props.ZipCodes.length > 1) {
            await this.props.setStateParams(
              "county",
              window.sessionStorage.getItem("countySelect")
            );
          }
          if (call === true) {
            const params = this.props.ZipCodes.filter(
              (zipcode1) =>
                zipcode1.countyName.search(
                  window.sessionStorage.getItem("countySelect")
                ) != -1
            );

            let body = { customerId: this.props?.customerId };
            await this.props.getPlans(
              zipcd,
              params[0]?.countyCode,
              body.customerId,
              params[0]?.stateCode,
              this.props?.year
            );

            if (this.props.cardDetails && this.props.cardDetails.length > 0) {
              let payload = { planYear: this?.props?.year };
              this.props.yearSelection(payload);
              await this.props.setStateParams("preEnrollInfo", {});

              history.push("/e-Enroll/select-plan");
            }
          }
        }
      }
    }
  }
  componentDidMount = async () => {
    this.props.setPageName("select-plan");
    {
      JSON.parse(window.sessionStorage.getItem("agentLoggedIn")) &&
        this.props.setLoginStateParams(
          "agentLoggedIn",
          JSON.parse(window.sessionStorage.getItem("agentLoggedIn"))
        );
    }
    {
      JSON.parse(window.sessionStorage.getItem("beneficiaryLogin")) &&
        this.props.setLoginStateParams(
          "beneficiaryLogin",
          JSON.parse(window.sessionStorage.getItem("beneficiaryLogin"))
        );
    }
    {
      JSON.parse(window.sessionStorage.getItem("guestLogin")) &&
        this.props.setLoginStateParams(
          "guestLogin",
          JSON.parse(window.sessionStorage.getItem("guestLogin"))
        );
    }
    //previewpge redirecting to select plan showin all cards
    if (window.sessionStorage.getItem("year")) {
      this.props.setStateParams("year", window.sessionStorage.getItem("year"));
    }
    if (JSON.parse(window.sessionStorage.getItem("keyCloakData"))) {
      await this.props.setLoginStateParams(
        "agencyIDSelected",
        window.sessionStorage.getItem("agencyId")
      );
      let keyCloakData = JSON.parse(
        window.sessionStorage.getItem("keyCloakData")
      );
      let { firstName, lastName, agentDetails, tokenExpiry, userId } =
        keyCloakData;
      let data2 = {
        firstName: firstName ?? "",
        lastName: lastName ?? "",
        agentFullName: agentDetails?.agentName ?? "",
        agentPhone: agentDetails?.agentPhone ?? "",
        agentId: agentDetails?.agentId ?? "",
        idleTime: tokenExpiry ?? "",
        userId: userId ?? "",
        agentEmailId: agentDetails?.agentEmail ?? "",
      };
      await this.props.setLoginStateValues(data2);
    }
    //checking user session....
    if (
      !this.props.agentLogin &&
      !this.props.guestLogin &&
      !this.props.beneficiaryLogin
    ) {
      history.push("/e-Enroll/Login");
    }
    await this.props.setStateParams("planType", "");
    await this.props.setStateParams("product", "");
    this.setState({
      planTypeFilter: "",
    });
    if (window.innerWidth <= 1100) {
      this.setState({ ...this.state, sidebarExpanded: false });
    }
  };
  toggle = async () => {
    let sideExpand = !this.state.sidebarExpanded;
    await this.setState({
      sidebarExpanded: sideExpand,
    });
  };

  handleCompareList = async (list) => {
    let productIsSupp = false;
    list.map((productId) => {
      productIsSupp = this.props.cardDetails.find(
        (det) =>
          det.productId === productId && det.productName.includes("Supplement")
      );
    });
    if (productIsSupp) {
      await this.props.setStateParams("detailsPlanType", "supplement");
    }
    await this.setState({
      compareList: list,
    });
  };
  handleReset = async () => {
    await this.setState({
      planTypeFilter: "",
      premiumFilter: "",
      productFilter: "",
    });
  };
  handleReset2 = async () => {
    await this.setState({
      planTypeFilter: "",
      premiumFilter: "",
    });
  };

  handleFilter = async (filterType, filterData) => {
    await this.setState({
      [filterType]: filterData,
    });
  };

  render() {
    const {
      sidebarExpanded,
      compareList,
      planTypeFilter,
      premiumFilter,
      productFilter,
    } = this.state;

    return (
      <div>
        <div>
          <div className={"wrapper wrapper3"}>
            <div class={sidebarExpanded ? "sidebar" : "sidebar sidebar-active"}>
              <div
                class={
                  this.props.agentLogin === true
                    ? "nav-slide shiftdown"
                    : "nav-slide shiftdown2"
                }
              >
                <Sidebar
                  compareList={[...compareList]}
                  handleFilter={this.handleFilter}
                  handleReset={this.handleReset}
                  handleReset2={this.handleReset2}
                  toggle={this.toggle}
                  clicked={this.state.clicked}
                  removeCompareList={() => {
                    this.setState({ ...this.state, compareList: [] });
                  }}
                />
              </div>
            </div>

            <PlansList
              toggle={this.toggle}
              handleCompareList={this.handleCompareList}
              planTypeFilter={planTypeFilter}
              premiumFilter={premiumFilter}
              productFilter={productFilter}
              sidebarExpanded={this.state.sidebarExpanded}
              handleHeaderWidth={() => {
                this.setState({ ...this.state, clicked: !this.state.clicked });
              }}
              compareList={compareList}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    customerId: state.login.customerId,
    lang: state.webApp.language,
    agentLogin: state.login.agentLoggedIn,
    guestLogin: state.login.guestLogin,
    email: state.login.agentEmailId,
    cardDetails: state.webApp.planCardData,
    token: state.login.token,
    zipCode: state.webApp.zip,
    ZipCodes: state.webApp.zipCodes,
    firstName: state.login.firstName,
    emailAddress: state.login.emailAddress,
    dpemail: state.login.dpemail,
    isAgentRole: state.webApp.isAgentRole,
    isSuperUser: state.webApp.isSuperUser,
    agentEmailId: state.login.agentEmailId,
    beneficiaryLogin: state.login.beneficiaryLogin,
    selectedProduct: state.webApp.selectedProduct,
    selectedPlansForCompare: state.webApp.selectedPlansForCompare,
    planType: state.webApp.planType,
    agencyIDSelected: state.login.agencyIDSelected,
    agencyID: state.login.agencyID,
  };
};
const mapDispatchToProps = {
  yearSelection,
  removeplan,
  agentCategoryDashboard,
  setStateParams,
  setLoginStateParams,
  getPlansEmail,
  guestLogin,
  setTokenTORedux,
  setDeepLink,
  getZipCodes,
  getPlans,
  setPageName,
  getKeyCloakToken,
  setLoginStateValues,
  getAgencyId,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectPlan);
